<template>
  <div data-cy="mle-search-view">
    <EquipmentEditHeader v-if="isAdmin" data-cy="equipment-edit-header" />
    <EquipmentTable
      data-cy="equipment-table"
      @select="$emit('select', $event.data as Motor_Lead_Extensions)"
    />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import { useMles } from "@/composables/equipment/mles/mles";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Motor_Lead_Extensions } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Motor_Lead_Extensions): void;
}>();

const mleSearch = useMles(props.isAdmin);

provide("equipment", mleSearch);
</script>
